import { createGlobalStyle } from 'styled-components';
import 'bootstrap/dist/css/bootstrap.min.css';
import robotoFont from '~/assets/fonts/Roboto-Regular.ttf';
import robotoBoldFont from '~/assets/fonts/Roboto-Bold.ttf';
import robotoMediumFont from '~/assets/fonts/Roboto-Medium.ttf';
import robotoLightFont from '~/assets/fonts/Roboto-Light.ttf';
import heeboFont from '~/assets/fonts/Heebo-Regular.ttf';
import heeboBoldFont from '~/assets/fonts/Heebo-Bold.ttf';
import heeboMediumFont from '~/assets/fonts/Heebo-Medium.ttf';
import heeboLightFont from '~/assets/fonts/Heebo-Light.ttf';
//styled.div
export const AppStyled = createGlobalStyle`
  * {
    position: relative;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html,
  body {
    font-size: 14px;
    font-family: Roboto;
    font-weight: normal;

    html[dir='rtl'] & {
      font-family: Heebo;
    }
  }

  @font-face {
    font-family: Heebo;
    src: url(${heeboLightFont});
    font-weight: 100;
  }
  @font-face {
    font-family: Heebo;
    src: url(${heeboFont});
    font-weight: normal;
  }

  @font-face {
    font-family: Heebo;
    src: url(${heeboBoldFont});
    font-weight: bold;
  }

  @font-face {
    font-family: Heebo;
    src: url(${heeboMediumFont});
    font-weight: 500;
  }

  @font-face {
    font-family: Roboto;
    src: url(${robotoFont});
    font-weight: normal;
  }

  @font-face {
    font-family: Roboto;
    src: url(${robotoBoldFont});
    font-weight: bold;
  }

  @font-face {
    font-family: Roboto;
    src: url(${robotoMediumFont});
    font-weight: 500;
  }

  @font-face {
    font-family: Roboto;
    src: url(${robotoLightFont});
    font-weight: 100;
  }

  .form-group {
    width: 100%;
  }

  .form-label {
    font-size: 1.2857rem;
  }

  .form-control,
  .customSelect .SelectGroup__control {
    width: 100%;
    height: 5rem;
    font-size: 1.2857rem;
    padding: 0 2.1rem;
    color: #2a6fdb;
    font: normal normal normal 1.2857rem Roboto, Heebo;

     html[dir='rtl'] & {
      font-family: Heebo;
    }

    background: #e6e6e6 0% 0% no-repeat padding-box;
    border-radius: 2.1rem;
    border: transparent;
    box-shadow: none;

    &:focus,
    &:active {
      color: #2a6fdb;
      background: #e6e6e6 0% 0% no-repeat padding-box;
      border-color: transparent;
      outline: none;
      box-shadow: none;
    }
    &:disabled {
      color: #999999 !important;
      cursor: not-allowed;
      user-select: none;
    }
  }

  .customSelect .SelectGroup__control {
    span[class$='indicatorSeparator'] {
      width: 0;
    }
  }
  .SelectGroup__menu {
    top: 120%;
    box-shadow: 0px 3px 6px #00000029;
    border: 2px solid #e6e6e6;
    z-index: 6 !important;
    &::before {
      position: absolute;
      content: '';
      border: 2px solid #e6e6e6;
      top: -15px;
      left: 35px;
      height: 30px;
      width: 30px;
      background: #fff;
      clip-path: polygon(0 0, 0 100%, 100% 0);
      transform: rotateZ(45deg);
      z-index: 3;
    }
  }

  .modal-content {
    border-radius: 20px;
    box-shadow: 0px 3px 6px #00000029;
    border: 1px solid #e6e6e6;

    .modal-header {
      justify-content: center;
      padding: 30px 0;
      border-bottom: none;

      .modal-title {
        font: normal normal bold 30px/37px Roboto, Heebo;
        letter-spacing: 0px;
        color: #2a6fdb;

        html[dir='rtl'] & {
          font-family: Heebo;
        }
      }
    }

    .modal-body {
      padding: 10px 30px;
    }
  }

  .rc-time-picker-panel-inner {
    position: absolute;
    top: 72px;
    left: 60px;
    width: 115px;

    .rc-time-picker-panel-input-wrap {
      display: none;
    }

    .rc-time-picker-panel-select {
      &::-webkit-scrollbar {
        display: none;
      }
    }

    .rc-time-picker-panel-select li{
      font: normal normal normal 15px/18px Roboto, Heebo;
    }
  }

  @media (min-width: 576px) {
    .modal-dialog {
      min-width: 650px;
    }
  }

  @media screen and (max-width: 1500px) {
    html {
      font-size: 13px;
    }
  }
  @media screen and (max-width: 1420px) {
    html {
      font-size: 12.5px;
    }
  }
  @media screen and (max-width: 1350px) {
    html {
      font-size: 12px;
    }
  }
  @media screen and (max-width: 1280px) {
    html {
      font-size: 11.5px;
    }
  }
  @media screen and (max-width: 1200px) {
    html {
      font-size: 11px;
    }
  }
  @media screen and (max-width: 1170px) {
    html {
      font-size: 10.5px;
    }
  }
  @media screen and (max-width: 1100px) {
    html {
      font-size: 10px;
    }
  }
`;
